import React, { Component } from 'react';
import { addSession, loadSessionList, shareItems,comparedata, loadSessionItem, deleteSessionItem } from '../../State/actions/sessions';
import { connect } from 'react-redux';
import Spinning from 'grommet/components/icons/Spinning'
import Header from 'grommet/components/Header';
import Heading from 'grommet/components/Heading';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Paragraph from 'grommet/components/Paragraph';
//import Tile from 'grommet/components/Tile';
//import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import Layer from 'grommet/components/Layer';
import WarningIcon from 'grommet/components/icons/base/Alert';
import CloseIcon from 'grommet/components/icons/base/Close'
import Share from 'grommet/components/icons/base/Share';
//import Compare from './Compare';
import WorkLoadIcon from 'grommet/components/icons/base/DocumentConfig';
import SolutionIcon from 'grommet/components/icons/base/Info';
import Close from 'grommet/components/icons/base/Close';
import { said, appUrl } from '../../AppConfig';
import { interviewScreens } from '../../SizerScreens';
import { fetchSupportedList } from '../../State/actions/sessions';
var compare = ''
var SavedSolutionName=''
var DeleteLayer, ShareLayer;
const HPECP_SIZER = ('EzmeralCPSizer').toUpperCase();
var inputText=''
const EPAId = 'EPAvNext';
const BLUE_DATA = 'BlueData';
let OldSolutionLayer = '';
class LoadFiles extends Component {

  constructor() {
    super();
    this.state = { LoadItemIndex: '', WorkloadList: [], SolutionList: [], showLoading: false, CompareLayer: false, showShareLayer: false, shareId: '', displayOldSolutionContent: false, SelectedType: '', WorkloadnSolutionData: [] };
    this.onLoad = this.onLoad.bind(this);
    //DelSession: '',
    this.onDelete = this.onDelete.bind(this);
    this.OnShare = this.OnShare.bind(this);
    this.Submit_Delete_WL = this.Submit_Delete_WL.bind(this);
    this.shareClicked = this.shareClicked.bind(this);
    this.onCompare = this.onCompare.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }


  componentDidMount() {
    var userId = this.props.UserID;
    var subsaid = null;
    if (userId === undefined) {
      userId = 'TestUser@test.com';
    }
    if (said === 'EPAvNext') {
      if (appUrl.toUpperCase().indexOf(HPECP_SIZER) > -1) {
        subsaid = "<WorkloadType>BlueData</WorkloadType>" ;
      } else {
        subsaid = "<WorkloadType>BigData</WorkloadType>";
      }
    }else if (said === 'SAPHANA' && this.props.SSETid!==undefined) {
     if (this.props.WorkloadType!==undefined && this.props.WorkloadType.toUpperCase().indexOf('TDI') > -1) {
        subsaid = "<WorkloadType>TDI</WorkloadType>" ;
      } else {
        subsaid = "<WorkloadType>SAPHANA</WorkloadType>";
      }
    }

    var userData = {
      //"UserId": this.props.userData.email,
      "UserId": userId,
      "SizerId": said,
      "subSAID": subsaid
    };
    this.props.onLoadWokload(userData);
    if (said === 'EPA') {
      this.props.onUpdateDefaultSession(this.props.DefaultInputs);
      if (this.props.supportedList === null)
        this.props.OnFetchSupportedList();
    }
    else if (said === 'SAPHANA') {
      this.props.onUpdateDefaultSession(this.props.DefaultInputs);
    }
  }

  CloseDelSession() {
    DeleteLayer = ''
    this.setState({})
  }

  CloseOldSolutionLayer = () => {
    OldSolutionLayer = '';
    this.props.updateLoadedOldSolution(false);
    this.setState({displayOldSolutionContent : false});
  }

  onLoad(index) {
    var selection = 0;
    if (this.props.title === 'Workload') {
//Devendu Changes 25052020
      if(this.props.guiState!=undefined){
        this.props.guiState.loadWorkload = true;
      }
      this.state.WorkloadList.filter((value, id) => {
        if (index === id) {
          selection = value['id'];
        }
      });
      // this.props.onAddSession(Date.now(),'Load Workload Session');
      this.props.onLoadSession({ "ID": selection });
      // this.props.history.push('/Build/ContactInfo');
      // this.props.onClose(false);
      // this.props.redirectTo('/Build/ContactInfo');

    } else if (this.props.title === 'Solution') {
//Devendu Changes 25052020
      if(this.props.guiState!=undefined){
        this.props.guiState.loadSolution = true;
      }
      this.state.SolutionList.filter((value, id) => {
        if (index === id) {
          selection = value['id'];
        }
      });
      // this.props.onAddSession(Date.now(),'Load Solution Session');
      this.props.onLoadSession({ "ID": selection });
      // this.props.onClose(false);
      // this.props.redirectTo('/Build/SolnAlternative');
      // this.props.history.push('/Build/SolnAlternative');
    } else if (this.props.title === 'All') {
      if (this.state.SelectedType === 'Workload') {
        if (this.props.guiState != undefined) {
          this.props.guiState.loadWorkload = true;
        }
      } else {
        if (this.props.guiState != undefined) {
          this.props.guiState.loadSolution = true;
        }
      }
      this.state.WorkloadnSolutionData.filter((value, id) => {
        if (index === id) {
          selection = value['id'];
        }
      });
      this.props.onLoadSession({ "ID": selection });
    }

    // this.props.onAddSession(Date.now(),'Loaded Workload');
    // if(this.props.activeSession !== ''){
    //   this.props.activeSession.workload = DataObj.Workloads.Workload[index]["Content"];
    //   this.props.onClose(false);
    //   this.props.history.push('/Build/ContactInfo');
    // }
  }

  Submit_Delete_WL(index) {
    var selection = 0;
    if (this.props.title === 'Workload') {
      this.state.WorkloadList.filter((value, id) => {
        if (index === id) {
          selection = value['id'];
        }
      });
      this.props.onDeleteSession({ "ID": selection });
    } else if (this.props.title === 'Solution') {
      this.state.SolutionList.filter((value, id) => {
        if (index === id) {
          selection = value['id'];
        }
      });
      this.props.onDeleteSession({ "ID": selection });
    } else { }
    DeleteLayer = '';
  }
  handleClose() {
    compare = ''
    this.props.onClose(false)
    this.setState({ CompareLayer: false })
  }
 handleCloseError(){
    compare = ''
      this.setState({ CompareLayer: false })
  }

  shareClicked(id) {
    this.setState({ showLoading: true });
    var item;
    if (this.props.title === 'Solution')
      item = this.state.SolutionList[this.state.LoadItemIndex];
    /*Changes by Vinay replaced else if (this.props.title === 'Workload') condition by else, for CID:'10625'*/
    else
      item = this.state.WorkloadList[this.state.LoadItemIndex];

    var userData = {
      "itemId": item.id,
      "userIdtoShareWith": this.state.shareId.split(',')
    };

    this.props.onShareItems(userData);
  }
  onCompare(index) {
    var selectedselection = 0
    var activeSessionid = this.props.activeSession.id
    this.state.SolutionList.filter((value, id) => {
      if (index === id) {
        selectedselection = value['id'];
      }
    });
    
    this.props.Savedname(SavedSolutionName,selectedselection);
    this.props.onClose(false)
    var value = {
      "SessionID": activeSessionid,
      "SessionIDsaved": selectedselection,
      "EPASolutionType" : this.props.solutionIndex
    }
    this.props.OnComparedata(value)
    this.setState({ CompareLayer: true })
  }

  OnShare(id) {
    var shareItem;

    if (this.props.title === 'Solution')
      shareItem = this.state.SolutionList[id];
    /* Changes by Vinay, replaced "else if (this.props.title === 'Workload')" with "else", for CID:10626 */
    else
      shareItem = this.state.WorkloadList[id];

    var text = 'Sharing';
    var textStyle;
    var method = this.shareClicked;
    
    if (this.state.showLoading) {
      method = undefined;
    }   
    this.state.shareId.split(',').map((emailId,index)=>{
      if (! /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailId)) {
   		  method = undefined;
      }
    });
    
    var responseData  =  this.props.responseFromShare.response!=='' ? this.props.responseFromShare.response.map((item,index)=>{
       item.status==='Error' ?  textStyle={color:'red', paddingTop: '10px' } : textStyle={color:'#01a982', paddingTop: '10px' };        
      return <Heading tag='h5' margin='none' style={textStyle}>{item.message}</Heading>
    }):'';


    text += ' ' + shareItem.type + " - " + shareItem.alias;

    ShareLayer = <Layer>
      <Box margin='none' pad='none' size='large' >
        <Box direction="row" colorIndex="neutral-1" margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
          <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
            <Share size='small' colorIndex='warning' />
            <Heading tag="h4" strong={false} >Share</Heading>
          </Box>
          <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={() => {
            if (!this.state.showLoading) {
              ShareLayer = ''; 
              this.setState({ showShareLayer: false });
              this.props.responseFromShare.response='';
              this.setState({shareId:''});
            }
          }
          } >
            <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
          </Box>
        </Box>
        <Box pad='small'>
          <Heading tag='h5' strong={true}>{text}</Heading>

          <Heading tag='h5' >Please Enter a valid user email id and click on share</Heading>

          <Box direction='row' style={{ width: '100%' }}>
            {
              this.state.showLoading ? <TextInput disabled style={{ width: '60%', marginRight: '10px' }} ></TextInput> :
                <TextInput value={this.state.shareId} onDOMChange={(e) => { this.setState({ shareId: e.target.value }) } } style={{ width: '60%', marginRight: '10px' }} ></TextInput>
            }
            <Button primary={true} label='Share' onClick={method}></Button>
          </Box>

          {this.state.showLoading ?
            <Box direction='row' style={{ paddingTop: '10px' }} size='medium' pad={{ 'between': 'small' }}>
              <Spinning size='small' className='spinnerStyle' />
              <Heading tag='h5' strong={true} margin='none'>Please wait while we share...</Heading>
          </Box> : 
          <Box>
          {responseData}
          </Box>
          }
        </Box>
      </Box>
    </Layer>

     if (!this.state.showShareLayer) {
    	 this.setState({ showShareLayer: true });
     }
  }

  onDelete() {
    //this.setState({DeletePopup:true})
    DeleteLayer = <Layer>
      <Box margin='none' pad='none' size='medium' >
        <Box direction="row" colorIndex="neutral-1" margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
          <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
            <WarningIcon size='small' colorIndex='warning' />
            <Heading tag="h4" strong={false} >Please Confirm</Heading>
          </Box>
          <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.CloseDelSession.bind(this)} >
            <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
          </Box>
        </Box>
        <Box margin="none" pad="small">
          <Heading tag='h6' strong={false} margin='none'>{
            this.props.title === "Solution" ? "Are you sure you want to delete the selected Solution?" : "Are you sure you want to delete the selected Workload ?"
          }
          </Heading>

        </Box>
        <Box direction='row' justify='end' margin='none' pad='small'>
          <Button label='Yes' className="SessionOutBtns" onClick={() => this.Submit_Delete_WL(this.state.LoadItemIndex)} />
          <Button label='No' className="SessionOutBtns" critical={true} onClick={this.CloseDelSession.bind(this)} />
        </Box>
      </Box>
    </Layer>

    this.setState({});
  }

  componentWillReceiveProps(nextProps) {
    this.state.WorkloadList = [];
    this.state.SolutionList = [];
    if (nextProps.loadedOldSolution) {
      if (said === EPAId) {
        this.state.displayOldSolutionContent = true;
      }
    }
    nextProps.userData.map((value, index) => {
      if (value['type'].indexOf('Workload') === 0) {
        if (this.state.WorkloadList.indexOf(value) !== 0) {
          this.state.WorkloadList.push(value);
        }
      } else {
        if (this.state.SolutionList.indexOf(value) !== 0) {
          this.state.SolutionList.push(value);
        }
      }
    });

    this.state.WorkloadnSolutionData = [];
    if (this.props.title === 'All') {
      this.state.WorkloadList.map((value, index) => {
        this.state.WorkloadnSolutionData.push(value);
      })
      this.state.SolutionList.map((value, index) => {
        this.state.WorkloadnSolutionData.push(value);
      })
    }


    /*var selsessionID = '';
    if (nextProps.title === 'Workload') {
      this.state.WorkloadList.filter((value, id) => {
        if (this.state.LoadItemIndex === id) {
          selsessionID = value['sessionID'];
        }
      });
    } else if (nextProps.title === 'Solution') {
      this.state.SolutionList.filter((value, id) => {
        if (this.state.LoadItemIndex === id) {
          selsessionID = value['sessionID'];
        }
      });
    }*/

    if (nextProps.activeSession.id != "") {
      if (nextProps.activeSession.id !== this.props.activeSession.id) {
        if (nextProps.activeSession.treeView !== '') {
          let obj = "";
          if (said === 'CS750VirtSizer' || said === 'SynergySizer') {
            obj = {
              "Workload": nextProps.activeSession.workload
            }
          }
          else {
            obj = nextProps.activeSession.workload;
          }
          if (said === EPAId && nextProps.activeSession.workload.UserInputs.Environments.WorkloadType === BLUE_DATA) {
            if (Array.isArray(nextProps.activeSession.workload.UserInputs.Environments.Environment)) {
              this.props.onNewSession(obj);
              this.props.redirectTo('/Build/SolnAlternative');
            }
          } else {
            this.props.onNewSession(obj);
            this.props.redirectTo('/Build/SolnAlternative');
          }
          // this.props.history.push('/Build/SolnAlternative');
        } else {
          let obj = "";
          if (said === 'CS750VirtSizer' || said === 'SynergySizer') {
            obj = {
              "Workload": nextProps.activeSession.workload
            }
          }
          else {
            obj = nextProps.activeSession.workload;
          }
          this.props.onNewSession(obj);

          if (said === 'EPAvNext' ||said === 'SAPHANA') {
            var specificPages = interviewScreens.filter((route, id) => {
              if (route.type === nextProps.activeSession.workload.UserInputs.Environments.WorkloadType) {
                return route;
              }
            });
            this.props.redirectTo(specificPages[0].path);
          }
          else {
            this.props.redirectTo(interviewScreens[0].path);
          }
          // this.props.history.push('/Build/ContactInfo');
        }
      }
    }

    if(this.state.showLoading && this.props.responseFromShare.response !== nextProps.responseFromShare.response)
    {
      this.setState({showLoading:false});
    }

  }

  render() {
    var TileItems = '';
    if (this.props.userData.length > 0) {
      // this.props.userData.map( (value, index) => {
      //       if(value['type'].indexOf('Workload') === 0 ){
      //           if(this.state.WorkloadList.indexOf(value) !== 0 ){
      //             this.state.WorkloadList.push(value);
      //           }
      //       }else{
      //           if(this.state.SolutionList.indexOf(value) !== 0 ){
      //             this.state.SolutionList.push(value);
      //           }
      //       }
      // });

      // <Header size='small' pad={{"horizontal": "small"}}>
      //      <Box direction="row" margin="none" pad={{between: 'small'}} >
      //           <Box className='WorkloadItemIcon'>
      //             <WorkLoadIcon size='small' />
      //           </Box>
      //           <Heading tag='h5' strong={true} margin='none'>
      //             {value['id']}
      //           </Heading>
      //     </Box>
      // </Header>

      // <Header size='medium' pad={{"horizontal": "small"}}>
      //      <Box direction="row" margin="small" pad={{between: 'small'}} >
      //           <Box justify='center' className='SolutionItemIcon'>
      //                <SolutionIcon size='medium' />
      //           </Box>
      //           <Box margin="none" pad={{between: 'small'}}>
      //                <Box direction="row" margin="none" pad={{between: 'small'}} > 
      //                     <Heading tag='h5' strong={true} margin='none' style={{color:'#01a982'}} >
      //                       ID:
      //                     </Heading>
      //                     <Heading tag='h5' strong={true} margin='none'>
      //                       {value['id']}
      //                     </Heading>
      //                </Box>
      //                <Box direction="row" margin="none" pad={{between: 'small'}} > 
      //                     <Heading tag='h5' strong={true} margin='none' style={{color:'#01a982'}} >
      //                       sessionID:
      //                     </Heading>
      //                     <Heading tag='h5' strong={true} margin='none'>
      //                       {value['sessionID']}
      //                     </Heading>
      //                </Box>
      //                <Box direction="row" margin="none" pad={{between: 'small'}} > 
      //                     <Heading tag='h5' strong={true} margin='none' style={{color:'#01a982'}} >
      //                       Created at:
      //                     </Heading>
      //                     <Heading tag='h5' strong={true} margin='none'>
      //                       {value['timestamp']}
      //                     </Heading>
      //                </Box>
      //           </Box>
      //     </Box>
      // </Header>

      if (this.props.title === 'Workload') {
        var selectionstyleing;
        if(this.state.WorkloadList.length>0){
        TileItems = this.state.WorkloadList.map((value, index) => {

          if (this.state.LoadItemIndex === index) {
            selectionstyleing = 'brand'
          } else {
            selectionstyleing = 'accent-2-t'
          }
          inputText = this.props.flag === true ? "Please select an item to Compare:" : "Please select an item to Load:";
          return (<Box key={index} separator='top' align='start' className='LoadBoxInside'
            onClick={() => { this.setState({ LoadItemIndex: index }) } }>

            <Header size='medium' pad={{ "horizontal": "small" }}>
              <Box direction="row" margin="small" pad={{ between: 'small' }} >
                <Box justify='center' className='WorkloadItemIcon'>
                  <WorkLoadIcon size='medium' colorIndex={selectionstyleing} />
                </Box>
                <Box margin="none" pad={{ between: 'none' }}>
                  <Box direction="row" margin="none" pad={{ between: 'small' }} >
                    <Heading tag='h5' strong={true} margin='none'>
                      {value['alias']}
                    </Heading>
                  </Box>
                  <Box direction="row" margin="none" pad={{ between: 'small' }} >
                    <Heading tag='h5' strong={false} margin='none' >
                      {value['timestamp']}
                    </Heading>
                  </Box>
                </Box>
              </Box>
            </Header>
          </Box>);

        });
      }else{
        inputText=" "
         TileItems =  <Box style={{alignItems:"center",justifyContent:'center',height:'300px'}}><Heading tag='h5'  margin='none'>No Workloads are saved</Heading></Box>
         
      }
      } else if (this.props.title === 'Solution') {
        if(this.state.SolutionList.length >0){
        TileItems = this.state.SolutionList.map((value, index) => {
          if (this.state.LoadItemIndex === index) {
            selectionstyleing = 'brand'
            SavedSolutionName=value.alias
           
          } else {
            selectionstyleing = 'accent-3-t'
          }
          inputText = this.props.flag === true ? "Please select an item to Compare:" : "Please select an item to Load:";
          
          return <Box key={index} separator='top' align='start' className={'LoadBoxInside ' + this.state.SelectedTabActive}
            onClick={() => { this.setState({ LoadItemIndex: index }) } } >
            <Header size='medium' pad={{ "horizontal": "small" }}>
              <Box direction="row" margin="small" pad={{ between: 'small' }} >
                <Box justify='center' className='SolutionItemIcon'>
                  <SolutionIcon size='medium' colorIndex={selectionstyleing} />
                </Box>
                <Box margin="none" pad={{ between: 'none' }}>
                  <Box direction="row" margin="none" pad={{ between: 'small' }} >
                    <Heading tag='h5' strong={true} margin='none'>
                      {value['alias']}
                    </Heading>
                  </Box>
                  <Box direction="row" margin="none" pad={{ between: 'small' }} >
                    <Heading tag='h5' strong={false} margin='none' >
                      {value['timestamp']}
                    </Heading>
                  </Box>
                </Box>
              </Box>
            </Header>
          </Box>
        });
      }else{
        inputText=" "
         TileItems =  <Box style={{alignItems:"center",justifyContent:'center',height:'300px'}}><Heading tag='h5'  margin='none'>No Solutions are saved </Heading></Box>
      }

    } else if (this.props.title === 'All') {
      var selectionstyleing;
      if (this.state.WorkloadnSolutionData.length > 0) {
        TileItems = this.state.WorkloadnSolutionData.map((value, index) => {
          if (this.state.LoadItemIndex === index) {
            selectionstyleing = 'brand'
          } else {
            selectionstyleing = 'accent-2-t'
          }
          inputText = this.props.flag === true ? "Please select an item to Compare:" : "Please select an item to Load:";
          return (<Box key={index} separator='top' align='start' className='LoadBoxInside'
            onClick={() => { this.setState({ LoadItemIndex: index, SelectedType: value.type }) }}>

            <Header size='medium' pad={{ "horizontal": "small" }}>
              <Box direction="row" margin="small" pad={{ between: 'small' }} >
                {value.type === 'Workload' ?
                  <Box justify='center' className='WorkloadItemIcon'>
                    <WorkLoadIcon size='medium' colorIndex={selectionstyleing} />
                  </Box>
                  :
                  <Box justify='center' className='SolutionItemIcon'>
                    <SolutionIcon size='medium' colorIndex={selectionstyleing} />
                  </Box>
                }
                <Box margin="none" pad={{ between: 'none' }}>
                  <Box direction="row" margin="none" pad={{ between: 'small' }} >
                    <Heading tag='h5' strong={true} margin='none'>
                      {value['alias']}
                    </Heading>
                  </Box>
                  <Box direction="row" margin="none" pad={{ between: 'small' }} >
                    <Heading tag='h5' strong={false} margin='none' >
                      {value['timestamp']}
                    </Heading>
                  </Box>
                </Box>
              </Box>
            </Header>
          </Box>);

        });
      }
    }
    else {
        TileItems = 'No Data available.';
      }

    }
    if (this.state.displayOldSolutionContent) {
      OldSolutionLayer = <Layer closer={false} overlayClose={true} >
        <Box margin="none" pad="none" size='medium'>
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon colorIndex='critical' size='small' />
              <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.CloseOldSolutionLayer} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="small" pad={{ between: 'small' }} >
            <Paragraph margin="small">Loaded workload/solution is saved in older version. Tool is updated with newer inputs and functionalities. Please build a new workload/solution.</Paragraph>
          </Box>
        </Box>
      </Layer>
    }
    if (this.state.CompareLayer && !this.props.isLoading && this.props.comparedata !== null &&this.props.comparedata.CompareData !=='File Mismatch') {
      // compare = <Layer margin="none" className="CompareTable" pad="small" style={{ width: '100% !important', zIndex: '500 !important' }}>
      //   <Box  margin="none" pad="none" align='start' alignContent="start"  >
      //     <Compare CloseLayer={this.handleClose.bind(this)} SavedSolName={SavedSolutionName}/>
      //   </Box>

      // </Layer>
    }
    else{
      if (this.props.comparedata !== null && !this.props.isLoading && this.state.CompareLayer &&this.props.comparedata.CompareData !== null && this.props.comparedata.CompareData ==='File Mismatch') {
      compare = <Layer closer={false} overlayClose={true} >
        <Box margin="none" pad="none" size='medium'>
          <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon colorIndex='critical' size='small' />
              <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.handleCloseError.bind(this)} >
              <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="small" pad={{ between: 'small' }} >
            <Paragraph margin="small" >{'Current solution is configured with different platform. Kindly select the solution with same platform to compare'}</Paragraph>
          </Box>
        </Box>
      </Layer>
    }
    }
    //var emllay = ''
    // if (this.state.EmailLayer) {
    //   emllay = <Layer margin="none" pad="small" style={{ width: '100% !important', zIndex: '500 !important' }}>
    //     <Box direction="row" margin="none" pad="none" align='start' alignContent="start"  >
    //       <FormField className="DiskCapacityDetails" label='Enter Email id with whom you want to share' error="(3-10)">
    //         <Box direction="row">
    //           <TextInput id='StoraegWorkload' value={"Xyz@mphasis.com"} />
    //         </Box>
    //       </FormField>
    //       <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" onClick={this.handleEmailClose.bind(this)} />
    //     </Box>
    //   </Layer>
    // }
    // var TileItems = DataObj.Workloads.Workload.map( (value, index) => {
    // DataObj.Workloads.Workload.map( (value, index) => {
    //          return <Tile key={index} basis='1/2' separator='top' align='start' > 
    //                       <Header size='small' pad={{"horizontal": "small"}}>
    //                            <Box direction="row" margin="none" pad={{between: 'small'}} >
    //                                 <Box className='WorkloadItemIcon'>
    //                                   <WorkLoadIcon size='small' />
    //                                 </Box>
    //                                 <Box className='SolutionItemIcon'>
    //                                   <SolutionIcon size='small' />
    //                                 </Box>
    //                                 <Heading tag='h4' strong={true} margin='none'>
    //                                   {value['@ID']}
    //                                 </Heading>
    //                           </Box>
    //                       </Header>
    //                       <Box pad='small'>
    //                            <Heading tag='h4' strong={true} margin='none'> {value['@Name']} </Heading>
    //                       </Box>
    //                 </Tile>        
    // });

    if (this.state.showShareLayer) {
    	this.OnShare(this.state.LoadItemIndex);
    }

    return (
      <Box direction="column" margin="none" pad="none" style={{ width: '100%', height: '100%' }} >
        <Box direction="row" colorIndex="neutral-1" margin="none" pad="small" separator="bottom">
          <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}>
            <Heading tag="h4" strong={true} style={{ marginBottom: '0px', color: '#01a982' }}>Your Saved {this.props.title}(s)</Heading>
          </Box>
          <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={() => this.props.onClose(false)} >
            <Close size='small' colorIndex='light-2' className="CloseIconStyle" />
          </Box>
        </Box>
        <Box direction="row" margin="none" style={{ padding: '12px 12px 0px 12px' }} >
          <Heading tag="h4" strong={false} margin='none' >
         {  /* {this.props.flag === true ? 'Please select an item to Compare:' : 'Please select an item to load:'}*/}
        { inputText}
          </Heading>
        </Box>
        <Box className='LoadScrTileContainer' margin="none" pad="small" separator="bottom">
          <Box direction="row" margin="none" pad="none" >
            {TileItems}
            {compare}
          </Box>
        </Box>
        <Box direction="row" margin="small" justify='end' separator="none" pad={{ between: 'small' }} >
          {this.state.LoadItemIndex === '' ?
            <Button primary={false} label={this.props.flag === true ? 'Compare' : 'Load'} />
            :
            this.props.flag === true ?
              <Button primary={false} label={'Compare'} onClick={() => this.onCompare(this.state.LoadItemIndex)} /> :
              <Button primary={false} label={'Load'} onClick={() => this.onLoad(this.state.LoadItemIndex)} />
          }
          {this.state.LoadItemIndex === '' ?
            this.props.flag === true ? '' :
              <Button primary={false} label='Delete' />
            :
            this.props.flag === true ? '' :
              <Button primary={false} label='Delete' onClick={() => this.onDelete(this.state.LoadItemIndex)} />
          }
          {this.state.LoadItemIndex === '' ?
            this.props.flag === true || this.props.SSETid !== undefined ? '' :
              <Button primary={false} label='Share' />
            :
            this.props.flag === true || this.props.SSETid !== undefined ? '' :
              <Button primary={false} label='Share' onClick={() => this.OnShare(this.state.LoadItemIndex)} />
          }
          <Button primary={false} label='Cancel' onClick={() => this.props.onClose(false)} critical={true} />
        </Box>
        {DeleteLayer}
        {ShareLayer}
        {OldSolutionLayer}
      </Box>


    );
  }
}

const mapStateToProps = (state) => {
  let workloadtype = "SAPHANA";
  if(state.sizerWorkload.workload.UserInputs!==undefined && state.sizerWorkload.workload.UserInputs.Environments)
  workloadtype = state.sizerWorkload.workload.UserInputs.Environments.WorkloadType;
  return {
    allSessions: state.sessions.sessions,
    activeSession: state.sessions.activeSession,
    DefaultInputs: state.sessions.sessionDefaults.inputs,
    userData: state.sessions.userData,
    supportedList: state.sizerWorkload.supportedList,
    UserID: state.auth.userData.hpclname,
    isLoading: state.sessions.isLoading,
    loadedOldSolution: state.sessions.loadedOldSolution || false,
   responseFromShare:state.sessions.feedback,
    comparedata: state.sessions.CompareData,
    // DefaultInputs: state.sessions.sessionDefaults.inputs,
    guiState: state.sizerWorkload.guiState, //Devendu Changes 25052020
    SSETid: state.sessions.SSETid,
    WorkloadType:workloadtype,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddSession: (id, name) => {
      dispatch(addSession(id, name));
    },
    onLoadWokload: (userData) => {
      dispatch(loadSessionList(userData));
    },
    onShareItems: (userData) => {
      dispatch(shareItems(userData));
    },
    onLoadSession: (selectedID) => {
      dispatch(loadSessionItem(selectedID));
    },
    onDeleteSession: (selectedID) => {
      dispatch(deleteSessionItem(selectedID));
    },
    onNewSession: (workload) => {
      dispatch({ type: 'UPDATE_SIZER_WORKLOAD', payload: workload })
    },
    onUpdateDefaultSession: (inputs) => {
      dispatch({ type: 'UPDATE_SESSION_DEFAULTS', payload: inputs })
    },
    OnFetchSupportedList: () => {
      dispatch(fetchSupportedList());
    },
    OnComparedata: (value) => {
      dispatch(comparedata(value));
    },
    updateLoadedOldSolution: (value) => {
      dispatch({ type: 'UPDATE_LOADED_OLD_SOLUTION', payload: value})
    }
  };

};

export default connect(mapStateToProps, mapDispatchToProps)(LoadFiles);






// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/LoadFiles.js